var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"AnimateSizeChange","mode":"out-in","css":false},on:{"enter":_vm.enter,"after-enter":_vm.afterEnter,"enter-cancelled":_vm.enterCancelled,"before-leave":_vm.beforeLeave,"leave":_vm.leave,"leave-cancelled":_vm.leaveCancelled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }